import { render, staticRenderFns } from "./PurchasePaymentForm.vue?vue&type=template&id=825a0244"
import script from "./PurchasePaymentForm.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports